import { rankingData } from '@/mocks/gossipData';

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-8 md:mb-12">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-100 flex items-center justify-center">
            <i className="ri-fire-line text-xl text-primary-500"></i>
          </div>
          <div>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
              实时热搜榜
            </h2>
            <p className="text-sm text-foreground-400 mt-0.5">今日吃瓜热度排行，数据实时更新</p>
          </div>
        </div>

        <div className="space-y-3">
          {rankingData.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-background-50 rounded-2xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-default group"
            >
              <div
                className={`w-9 h-9 md:w-10 md:h-10 rounded-xl flex items-center justify-center font-heading text-lg flex-shrink-0 ${
                  i < 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 font-medium truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </p>
              </div>
              <span
                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium flex-shrink-0 whitespace-nowrap ${
                  item.tag === '爆'
                    ? 'bg-primary-100 text-primary-700'
                    : item.tag === '热'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                }`}
              >
                {item.tag}
              </span>
              <span className="text-xs text-foreground-400 flex-shrink-0 hidden sm:block whitespace-nowrap">
                {item.heat}热度
              </span>
              <span className="flex-shrink-0">
                <i
                  className={`text-sm ${
                    item.trend === 'up'
                      ? 'ri-arrow-up-line text-primary-500'
                      : 'ri-arrow-down-line text-foreground-300'
                  }`}
                ></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}